import React from "react";
import PageBanner from "../components/PageBanner";
import "../styles/ContactUs.css";

import LoadingSpinner from "../components/LoadingSpinner";
import ContactUsHook from "../hooks/ContactUsHook";

const ContactUs = () => {
const { loading,
  language,
  error,
  handleSubmit,
  name,
  setName,
  phone,
  setPhone,
  email,
  setEmail,
  message,
  setMessage,}=ContactUsHook()
  // Text content for English and Arabic
  const text = {
    en: {
      name: "Name",
      phone: "Phone",
      email: "Email",
      message: "Message",
      submit: "Submit",
      namePlaceholder: "Enter your name",
      phonePlaceholder: "Enter your phone number",
      emailPlaceholder: "Enter your email",
      messagePlaceholder: "Enter your message",
    },
    ar: {
      name: "الاسم",
      phone: "الهاتف",
      email: "البريد الإلكتروني",
      message: "الرسالة",
      submit: "إرسال",
      namePlaceholder: "أدخل اسمك",
      phonePlaceholder: "أدخل رقم هاتفك",
      emailPlaceholder: "أدخل بريدك الإلكتروني",
      messagePlaceholder: "أدخل رسالتك",
    },
  };
  if (loading ) {
    return <LoadingSpinner />; 
  }
  return (
    <>
      <PageBanner />
      
    </>
  );
};

export default ContactUs;